const suggestedCareers = [
  { id: '11-2022.00', title: 'Sales Managers' },
  { id: '11-3031.00', title: 'Financial Managers' },
  { id: '15-1255.01', title: 'Videospiel-Designer' },
  {
    id: '25-1032.00',
    title: 'Lehrkräfte für Ingenieurwesen, postsekundär'
  },
  { id: '27-1022.00', title: 'Modedesigner' }
]

export default suggestedCareers
